<template>
  <div>
    <div class="row justify-content-end">
      <b-pagination
        class="m-t-10 m-b-10 m-r-20"
        v-model="pages"
        :total-rows="total"
        :per-page="limit"
        @change="customPageChange"
      ></b-pagination>
    </div>
  </div>
</template>
<style scoped></style>
<script>
  export default {
    props: {
      total: Number,
      limit: Number,
      pageChanged: {
        type: Function,
      },
    },
    data() {
      return {
        pages: 1,
      };
    },
    methods: {
      customPageChange(customCurrentPage) {
        this.pageChanged({ currentPage: customCurrentPage });
      },
    },
  };
</script>
